import styled from 'styled-components';

import { ActionButton } from 'components/action-button';

import { CardContainer } from '../../loyalty-incentives-components/incentive-card/incentive-card.styled';

export const OffersInCartWrapper = styled.div`
  background: ${Styles.color.grey.five};
  padding: 0.25rem;
  ${CardContainer}:last-child {
    border-block-end: none;
  }
`;

export const OffersInCartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.5rem;

  p {
    margin: 0;
    font-size: 0.875rem;
    width: 100%;
  }

  div {
    justify-content: right;
  }
`;

export const OffersInCartRemoveButton = styled(ActionButton)`
  display: block;
  color: ${Styles.color.black};
  background-color: ${Styles.color.grey.five};
  font-size: 0.875rem;
  text-decoration: underline;
  border: none;
  cursor: pointer;
  padding: 0.25rem;

  &:focus,
  &:hover {
    color: ${Styles.color.secondary};
    background: ${Styles.color.grey.five};
    box-shadow: none;
  }
`;
